import React, { cloneElement } from'react';
import PropTypes from 'prop-types';
import Header from './components/Header';
import Title from './components/Title';
import './Authentication.css';

const AuthWrapper = ({
  title,
  children,
  ...rest
}) => {
  const Form = cloneElement(children, rest);

  return (
    <div className="auth">
      <Header/>
      <Title title={title}/>
      <div className="auth__wrapper">
        {Form}
      </div>
    </div>
  );
};

AuthWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

export default AuthWrapper;


// WEBPACK FOOTER //
// ./src/components/Authentication/AuthWrapper.js